<template>
    <div class="app flex-row align-items-center">
      <div class="row" style="margin: 0px">
        <div v-if="loading" class="loader"></div>
        <div class="events" v-show="!loading">
          <div class="event" id="live-widget"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LiveEventWidget',
    data() {
      return {
        loading: false,
        params: {}
      };
    },
    methods: {
      loadScript(src, id) {
        return new Promise((resolve, reject) => {
          if (document.getElementById(id)) {
            console.warn(`Script already exists: ${id}`);
            return resolve();
          }
          const script = document.createElement('script');
          script.id = id;
          script.type = 'text/javascript';
          script.async = true;
          script.src = src;
  
          script.onload = () => resolve();
          script.onerror = () => reject(new Error(`Script load error: ${src}`));
          document.head.appendChild(script);
        });
      },
      async initializeIntegration(paramsData) {
        try {
          await this.loadScript(
            `${paramsData.server}/js/partner/bootstrapper.min.js`,
            'js-content-mobile'
          );
  
          const bootConfig = { name: 'EventWidget' };
          const multiBootConfig = {
            defaultLanguage: 'tr',
            server: paramsData.server,
            sportPartner: paramsData.partner_id,
            apps: [
              {
                appConfig: { containerId: 'live-widget', type: 'Live' },
                bootConfig: { ...bootConfig },
                instanceName: 'Live',
                isMobileSwipeable: true,
                method: 'boot'
              }
            ]
          };
  
          const topWidgets = await Bootstrapper.multiBoot(
            multiBootConfig,
            bootConfig.name,
            () => {}
          );
  
          if (!topWidgets) {
            console.error('topWidgets undefined');
            return;
          }
  
          window.addEventListener('message', message => {
            if (message.data.url === '/Betting/AddStake') {
              this.$router.push('/live');
            }
          });
        } catch (error) {
          console.error('Error during integration:', error);
        }
      },
      async fetchData() {
        this.loading = true;
        try {
          const response = await axios.get('/sportsbook?service=digitain');
          if (response.data.status) {
            this.params = response.data.data;
            await this.initializeIntegration(this.params);
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.fetchData();
    }
  };
  </script>
  
  <style lang="scss">
  #app.mobile{
    .events{
        width: calc(100% + 5px);
        margin: 0 0px !important;
    }
  }
  .events {
    width: calc(100% + 20px);
    margin: 0 -10px !important;
    .event {
      width: 100%;
    }
  }
  </style>